export default "__VITE_ASSET__PWS0YU8s__"